// extracted by mini-css-extract-plugin
export default {"container":"BlogPage_container__lHA2i","posts-row":"BlogPage_posts-row__6mrz3","posts-col":"BlogPage_posts-col__yBnz+","blog-rect":"BlogPage_blog-rect__de8D-"};